export default __webpack_public_path__ + "static/ai-067679cddbc3eec01dd288c0a7a8e552.svg";